import { useTranslation } from "react-i18next";
import { useShuffled } from "~/lib/use-shuffled";
import {
  ReviewsCarousel,
  reviewCardsFrom,
  withStockPhotos,
  type StockPhoto,
} from "~/components/reviews/ReviewsCarousel";
import { storeRatingItems } from "~/components/reviews/StoreRatings";
import type { ProductReviewsContent } from "~/data/products/types";
import { imageUrl } from "~/lib/image-url";

// Plain public/ paths with .avif/.webp siblings, which the cards opt into. `position` recenters
// each full-frame photo's focal point — see the same comment on home/Reviews.tsx's STOCK_IMAGES.
const STOCK_IMAGES: StockPhoto[] = [
  { src: imageUrl("/images/review-images/couple-on-phone.png"), position: "40% 50%" },
  { src: imageUrl("/images/review-images/woman-on-phone.png"), position: "1% 50%" },
  { src: imageUrl("/images/review-images/couple-on-porch.png"), position: "33% 50%" },
  { src: imageUrl("/images/review-images/man-on-phone.png"), position: "19% 50%" },
  { src: imageUrl("/images/review-images/key-handoff-family.png"), position: "58% 50%" },
];

interface ReviewsSectionProps {
  content: ProductReviewsContent;
}

export function ReviewsSection({ content }: ReviewsSectionProps) {
  const { t, i18n } = useTranslation("products");

  const stockImages = useShuffled(STOCK_IMAGES);
  const cards = withStockPhotos(
    reviewCardsFrom(content.reviews, {
      anonymousReviewer: t("pdp.reviews_anonymous_reviewer"),
      language: i18n.language,
    }),
    stockImages,
  );

  return (
    <ReviewsCarousel
      id="reviews"
      eyebrow={content.eyebrow ? t(content.eyebrow) : undefined}
      headline={t(content.headline)}
      ariaLabel={t("pdp.reviews_carousel_label")}
      cards={cards}
      socialProof={storeRatingItems(content.appRatings)}
    />
  );
}
